const api = window.API

// ------------------------------------
// Route will verify email
// body { email, code, lang }
// ------------------------------------
exports.email = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/status/email`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

// -----------------------------------------
// Cancel subscription with subscriptionID
// body { subscriptionID, type:"cancel" }
// -----------------------------------------
exports.abo = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/status/abo`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

exports.password = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/status/password`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )
}